export enum Languages {
    English = "en-EN",
    Romanian = "ro-RO"
}

export enum StringIndexedLanguages {
    English = <any>"en-EN",
    Romanian = <any>"ro-RO"
}